import React from 'react'
import PropTypes from 'prop-types'

import { Flex, Box } from '@chatterbug/aaron'

const UnitInfoSkeleton = ({ nameSection, iconSection, children }) => {
  return (
    <Flex
      as="article"
      flexWrap="nowrap"
      flexDirection={{ _: 'column', tablet: 'row' }}
      justifyContent="flex-start"
      alignItems="center"
    >
      {iconSection && (
        <Box
          flexShrink={0}
          mr={{ _: 0, tablet: '4x' }}
          mb={{ _: '3x', tablet: 0 }}
          width={96}
          height={96}
        >
          {iconSection}
        </Box>
      )}
      <Box>
        <Box
          as="h1"
          variant="text.h3"
          textAlign={{ _: 'center', tablet: 'left' }}
        >
          {nameSection}
        </Box>
        {children}
      </Box>
    </Flex>
  )
}

UnitInfoSkeleton.propTypes = {
  nameSection: PropTypes.any,
  iconSection: PropTypes.any,
  children: PropTypes.any,
}

export default UnitInfoSkeleton
